import { useGetReports } from '@vindr/services/actions/report.action';
import { REPORT_STATUS } from '@vindr/services/constants/report.constant';
import { formatDateColumn } from '@vindr/utils/dateTime';
import { Typography } from 'antd';
import { isEqual } from 'lodash';
import { Dispatch, memo } from 'react';
import { useTranslation } from 'react-i18next';
import Table from '../../ui/Table';
const { Title } = Typography;

const UpdateAtColumn = {
  [REPORT_STATUS.SUBMITTED]: 'updated_at',
  [REPORT_STATUS.APPROVED]: 'approved_at',
};

interface ReportHistory {
  reports: ReturnType<typeof useGetReports>['data']['data'];
  selectedReport: ReportHistory['reports'][number];
  setSelectedReport: Dispatch<any>;
  loading?: boolean;
}

const ReportHistory = ({ selectedReport, setSelectedReport, reports, loading }: ReportHistory) => {
  const { t } = useTranslation('Vindoc');

  return (
    <div className="flex-col">
      <Title level={4} className="mb-0 pb-3 pt-0">
        {t('Report History')}
      </Title>
      <div className="overflow-auto">
        <Table
          columns={[
            {
              title: t('#'),
              dataIndex: 'index',
              key: 'index',
              width: 40,
              render: (value, record, index) => reports?.length - index,
            },
            {
              title: t('Approver'),
              dataIndex: 'approver',
              key: 'approver',
              width: 200,
              ellipsis: true,
              render: (value) => value?.fullname,
            },
            {
              title: t('Updated At'),
              dataIndex: 'updated_at',
              key: 'updated_at',
              width: 140,
              // render: (text, record: typeof reports[number]) => {
              //   return formatDateColumn(record[UpdateAtColumn[record.status]]);
              // },
              render: (text) => formatDateColumn(text),
            },
            {
              title: t('Status'),
              dataIndex: 'status',
              key: 'status',
              width: 100,
              ellipsis: true,
              render: (value) => t(REPORT_STATUS[value]),
            },
          ]}
          dataSource={reports}
          rowKey="id"
          loading={loading}
          pagination={false}
          wrapperClassName="h-auto cursor-pointer w-full overflow-scroll"
          scroll={{ y: 180 }}
          rowSelection={{
            type: 'radio',
            columnWidth: 0,
            renderCell: () => null,
            selectedRowKeys: selectedReport ? [selectedReport?.id] : [],
            onChange: (selectedRowKeys, selectedRows) => {
              setSelectedReport(() => selectedRows[0]);
            },
          }}
          onRow={(record: typeof reports[number]) => {
            return {
              onClick: (event) => {
                event.stopPropagation();
                event.preventDefault();

                const report = reports.find((it) => it.id === record.id);

                setSelectedReport(report);
              },
            };
          }}
        />
      </div>
    </div>
  );
};

export default memo(
  ReportHistory,
  (prev, next) =>
    isEqual(prev.reports, next.reports) &&
    isEqual(prev.selectedReport, next.selectedReport) &&
    isEqual(prev.loading, next.loading)
);
